export enum KeyLogs {
    WFI_INGRESO_PORTAL_ASESOR_INVERSION = 'WFI_INGRESO_PORTAL_ASESOR_INVERSION',

}

export enum KeyMensajesSalida {
    ASUNTO_INGRESO_PORTAL_ASESOR_INVERSION = 'ASUNTO_INGRESO_PORTAL_ASESOR_INVERSION',
}
